<template>
  <!-- 关于我们 -->
  <div class="container" style="background: #f8f8f8">
    <div id="banner" ref="banner">
      <p class="contactC">联系我们</p>
      <p class="contactE">contact us</p>
    </div>
    <div class="main">
      <div class="content">
        <div class="contenItem">
          <div class="contenItemTitle">公司地址</div>
          <div class="contenItemTitle1">Company address</div>
          <p>电话：022-88957000</p>
          <p>Email：service@chinaott.net</p>
          <p>地址：天津市空港经济区环河北路80号空港商务园东区E5</p>
          <p>邮编：300308</p>
          <p>网址：www.chinaott.net</p>
        </div>
        <img class="contentImg" src="../../../assets/sub-image/map.png" alt="" />
      </div>
    </div>
    <!-- 底部链接加版权信息 -->
    <div class="footer">
      <div class="footer-content">
        <img class="logo" :src="logo" alt="" />
        <div style="text-align: center">
          <p class="breadcrumb">
            <span class="spanWord"  @click="sy">网站首页</span>
            <span>|</span>
            <span class="spanWord" @click="handleUs">关于我们</span>
            <span>|</span>
            <span class="spanWord" @click="handleUser">用户协议</span>
            <span>|</span>
            <span class="spanWord" @click="handlePrivacy">隐私协议</span>
            <span>|</span>
            <span class="spanWord" @click="handleContact">联系我们</span>
          </p>
          <div class="rightCopy">
             <p>广播电视节目制作经营许可证：（津）字第379号</p>
             <p>网络文化经营许可证：津网文[2016]1209-018号</p>
             <p>津ICP备12004891号</p>
          </div>
        </div>
        <img class="cord" :src="cord" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/home1-image/logo.png'
import cord from '@/assets/home1-image/cord.png'
import banner from '@/assets/home1-image/banner.png'
export default {
  name: 'contactUs',
  data () {
    return {
      logo: logo,
      cord: cord,
      defaultImg: banner
    }
  },
  mounted () {},
  methods: {
    sy () {
      this.$router.replace('/')
    },
    handleUs () {
      this.$router.replace('/aboutUs')
    },
    handleUser () {
      this.$router.replace('/useragreement')
    },
    handlePrivacy () {
      this.$router.replace('/privacyPolicy')
    },
    handleContact () {
      this.$router.replace('/contactUs')
    }
  }
}
</script>

<style scoped lang="less">
@import "index";
</style>
